import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

let socketInstance = null;

const getStoredToken = () => {
    const token = localStorage.getItem("token");
    if (!token) return null;

    try {
      const parsed = JSON.parse(token);
      return typeof parsed === "string" && parsed ? parsed : null;
    } catch (_err) {
      return token;
    }
};

function connectToSocket() {
    const token = getStoredToken();

    if (socketInstance) {
      if (token) {
        const currentToken = socketInstance.io?.opts?.query?.token;
        if (currentToken !== token && socketInstance.io?.opts) {
          socketInstance.io.opts.query = {
            ...(socketInstance.io.opts.query || {}),
            token,
          };
        }

        if (!socketInstance.connected) {
          socketInstance.connect();
        }
      }

      return socketInstance;
    }

    if (!token) {
      socketInstance = openSocket(getBackendUrl(), {
        autoConnect: false,
      });
      return socketInstance;
    }

    socketInstance = openSocket(getBackendUrl(), {
      transports: ["websocket"],
      query: {
        token,
      },
    });

    return socketInstance;
}

export default connectToSocket;
